import { css } from 'styled-components';
import { kebabCase } from 'lodash';

import { mediaDesktop, mediaTablet } from './responsive';
import { fonts } from './theme';

// Fix Safari mobile fix, where vh values are wrongly calculated
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
export const setVh = value => `calc(var(--vh, 1vh) * ${value})`;

export const hover = (content: string, mustHoldOnTablet = false) =>
  css`
    &:active {
      ${content}
    }

    ${(mustHoldOnTablet ? mediaDesktop : mediaTablet)(`
      &:hover {
        ${content}
      }
    `)}
  `;

export const setTypography = (category: keyof typeof fonts.scale) => `
  ${Object.entries(fonts.scale[category])
    .map(([key, value]) => {
      const isRemUnit = ['fontSize', 'letterSpacing'].includes(key);
      const isObject = ['fontSize', 'lineHeight'].includes(key);
      const parsedKey = kebabCase(key);
      return `${parsedKey}: ${isObject ? (value as any).mobile : value}${
        isRemUnit && value ? 'rem' : ''
      };`;
    })
    .join('\n')}

  ${mediaTablet(`
    ${Object.entries(fonts.scale[category])
      .filter(([key]) => ['fontSize', 'lineHeight'].includes(key))
      .map(([key, value]) => {
        const isRemUnit = ['fontSize'].includes(key);
        const parsedKey = kebabCase(key);
        return `${parsedKey}: ${(value as any).tablet}${
          isRemUnit && value ? 'rem' : ''
        };`;
      })
      .join('\n')}
  `)}
`;
